import { useState } from "react";

// import axios from 'axios'
import { useDispatch, useSelector } from "react-redux"
import marvarApi from "../../../../../api/marvarApi"
import { parseNumber } from "helpers"
import { onLogout } from "store"

import { useHelpers } from './useHelpers';
import { useGlobalStates } from './useGlobalStates';
import { useDefaultData } from './useDefaultData';
import { useForm } from './useForm';
import * as useFetchData from './useFetchData';
import { useActions } from './useActions';

import jsPDF from "jspdf";
import 'jspdf-autotable';
import { justifyText, justifyTextBox } from "common/PDFUtils/pdfUtils";

export const useFechInitCasesReceived = ({location, paramsURL}) => {

    const dispatch = useDispatch()

    const pdfLandscapeDoc = new jsPDF({
        orientation: 'landscape',
        unit: 'mm',
        format: 'letter',
    });
    const pdfPortraitDoc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'letter',
    });
    const pdfManager = {
        pdfLandscapeDoc,
        pdfPortraitDoc,
        justifyText,
        justifyTextBox
    }

    const Helpers = useHelpers()

    
    const { user } = useSelector((state) => state.auth) //TODO: Revisar usuario

    // globalStates -------------------------------------------------------------------------------
    const globalStates = useGlobalStates()

    // defaultData --------------------------------------------------------------------------------
    const defaultData = useDefaultData({Helpers})

    // Para la modal -------------------------------------------------------
    const { defaultDataModal } = defaultData
    const [ dataModal, setDataModal ] = useState(defaultDataModal)
    const toggle = (_, title, compont, dataRequest) => {
        setDataModal({
            ...defaultDataModal,
            open: !dataModal.open,
            titleModal: title,
            componentModal: compont,
            dataRequest: dataRequest
        })
    }   

    const FormLeases = useForm(defaultData.defaultFormLease)
    const FormDeposit = useForm(defaultData.defaultFormDeposit)
    const FormFiles = useForm(defaultData.defaultFormFiles)
    const FormLogBook = useForm(defaultData.defaultFormLogBook)
    const FormExpenses = useForm(defaultData.defaultFormExpense)
    const FormExpenseTransaction = useForm(defaultData.defaultFormExpenseTransaction)
    const ObservationsForm = useForm(defaultData.defaultObservationsForm)

    const Forms = {
        FormLeases,
        FormDeposit,
        FormFiles,
        FormLogBook,
        FormExpenses,
        FormExpenseTransaction,
        ObservationsForm
    }


    const defaultFetchParams = { 
        //------------- Generales
        marvarApi, user, dispatch, onLogout, location, paramsURL, pdfManager, parseNumber,
        //------------- globalStates
        // globalStates,
        //------------- defalutData
        defaultData, 
        //------------- Helpers
        Helpers,
        //------------- Forms
        Forms 
    }

    // -------------- Info del contrato/solicitud
    const fetchAllLeaseContracts = useFetchData.useFetchAllLeaseContracts({...defaultFetchParams})
    const fetchAllBanks = useFetchData.useFetchAllBanks({...defaultFetchParams})
    const fetchAllCashRegisters = useFetchData.useFetchAllCashRegisters({...defaultFetchParams})
    const fetchAllCustomers = useFetchData.useFetchAllCustomers({...defaultFetchParams})
    const fetchAllDeposits = useFetchData.useFetchAllDeposits({...defaultFetchParams})
    const fetchAllFiles = useFetchData.useFetchAllFiles({...defaultFetchParams})
    const fetchAllHouses = useFetchData.useFetchAllHouses({...defaultFetchParams})
    const fetchInfoLease = useFetchData.useFetchInfoLease({...defaultFetchParams})
    const fetchInfoDeposit = useFetchData.useFetchInfoDeposit({...defaultFetchParams})
    
    // -------------- Info de la bitacora
    const fetchInfoLogBook = useFetchData.useFetchInfoLogBook({...defaultFetchParams})

    // -------------- Info de gastos extra
    const fetchAllExtraExpenses = useFetchData.useFetchAllExtraExpenses({...defaultFetchParams})
    const fetchInfoExtraExpenses = useFetchData.useFetchInfoExtraExpenses({...defaultFetchParams})
    const fetchTransactionsByExpense = useFetchData.useFetchTransactionsByExpense({...defaultFetchParams})
    const fetchSpecificExpenseTransaction = useFetchData.useFetchSpecificExpenseTransaction({...defaultFetchParams})
    const fetchAllObservations = useFetchData.useFetchAllObservations({...defaultFetchParams})
   
    const FetchData = {
        // -------------- Info del contrato/solicitud
        fetchAllLeaseContracts,
        fetchAllBanks,
        fetchAllCashRegisters,
        fetchAllCustomers,
        fetchAllDeposits,
        fetchAllFiles,
        fetchAllHouses,
        fetchInfoLease,
        fetchInfoDeposit,
        // -------------- Info de la bitacora
        fetchInfoLogBook,
        // -------------- Info de gastos extra
        fetchAllExtraExpenses,
        fetchInfoExtraExpenses,
        fetchTransactionsByExpense,
        fetchSpecificExpenseTransaction,
        fetchAllObservations
    }

    const Actions = useActions({
        marvarApi,
        user,
        toggle,
        FetchData,
        globalStates,
        defaultData,
        Forms,
        Helpers
    })

    return Object.freeze({
        //------------- Generales
        dataModal, toggle, user, Helpers, pdfManager, parseNumber,
        globalStates,
        defaultData,
        FetchData,
        Forms,
        Actions
    })

}